import { useMemo } from 'react'
import { UsageCostAugmentedEntry } from '@/hooks'

export type DataCompleteness = {
    usnsWithData: number
    totalUsns: number
}

type DataCompletenessMap = Map<number, DataCompleteness>

type UseUsageAndCostDataCompletenessParams = {
    data: UsageCostAugmentedEntry[]
    totalUsns: number
}

export const useUsageAndCostDataCompleteness = ({
    data,
    totalUsns,
}: UseUsageAndCostDataCompletenessParams): DataCompletenessMap => {
    const dataCompletenessMap = useMemo(() => {
        const completenessMap = new Map<number, DataCompleteness>()

        for (const entry of data) {
            if (completenessMap.has(entry.date)) continue

            const completeness: DataCompleteness = {
                usnsWithData: entry.reportedUsns || 0,
                totalUsns,
            }

            completenessMap.set(entry.date, completeness)
        }

        return completenessMap
    }, [data, totalUsns])

    return dataCompletenessMap
}
